import Vue from 'vue'
import Router from '@/common/vueRouter'
import App from '../App.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*/:magazineType',
      component: App,
      props: route => ({
        page: route.query.page
      })
    }
  ],
  scrollBehavior(to) {
    if (to.hash) return {
      selector: to.hash,
      behavior: 'smooth'
    }
    return {
      x: 0,
      y: 0,
      behavior: 'smooth'
    }
  }
})
